<template>
  <div class="dialogClosePlan">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="需求编号：">
        <span>{{ channelNeedNo }}</span>
      </el-form-item>
      <el-form-item label="关闭原因：" prop="desc">
        <el-input
          type="textarea"
          v-model="ruleForm.desc"
          placeholder="请输入原因"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="closePlanFooter">
      <el-button type="primary" @click="submitForm('ruleForm')"
        >确认关闭</el-button
      >
    </div>
  </div>
</template>

<script>
import { abolishIcpProgramme, needCloseIcp } from "@/api/alicp.js";
export default {
  props: ["channelNeedNo"],
  data() {
    return {
      ruleForm: {
        desc: "",
      },
      rules: {
        desc: [{ required: true, message: "请输入原因", trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      let obj = {
        channelNeedNo: this.channelNeedNo,
        note: this.ruleForm.desc,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("tolkParent", { loading: true, dialog: true });
          needCloseIcp(obj).then((res) => {
            console.log(res);
            if (res.status == 0) {
              this.$message({
                message: "关闭需求成功！",
                type: "success",
              });
              this.$emit("tolkParent", { loading: false, dialog: false });
              this.ruleForm = {
                desc: "",
              };
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
              this.$emit("tolkParent", { loading: false, dialog: true });
            }
          });
        } else {
          this.$message({
            message: "请输入原因",
            type: "warning",
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.dialogClosePlan {
  width: 100%;
  .el-form {
    width: 100%;
    margin-top: 20px;
    .el-form-item {
      .el-form-item__content {
        .el-textarea__inner {
          height: 200px;
          width: 520px;
        }
      }
    }
  }
  .closePlanFooter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      background: #ff8a01;
      border: none;
    }
  }
}
</style>
